import type { FC } from 'react'

type Props = {
  children: React.ReactNode
}

const EvaluationResultRoot: FC<Props> = ({ children }) => {
  return <div className="">{children}</div>
}

export default EvaluationResultRoot
